import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Box } from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbar,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { useCallback, useEffect, useMemo, useState } from "react";
import { API } from "../../../api/API";
import { appColors } from "../../../constant/constant";
import useAuthStore from "../../../store/authStore";
import DeleteDialog from "../modals/DeleteModal";
import ModifiModule from "../modals/ModifiModule";
import RegisterModuleV2 from "../modals/RegisterModulev2";
import ViewModuleModal from "../ViewModule";
const actionTypes = {
  voir: "voir",
  modifier: "modifier",
  delete: "delete",
};
const iconList = [
  <VisibilityOutlinedIcon sx={{ color: appColors.secondary }} />,
  <TipsAndUpdatesIcon sx={{ color: appColors.secondary }} />,

  <DeleteOutlineOutlinedIcon sx={{ color: appColors.danger }} />,
];
const DataGridModule = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isVisibleViewModule, setIsVisibleViewModule] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pagination, setPagination] = useState({ page: 1, limit: 50 });
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isModifiDialogOpen, setIsModifiDialogOpen] = useState(false);
  const [rows, setRows] = useState([]);

  const user = useAuthStore((state) => state.user);

  const handleAction = useCallback((row, actionType) => {
    setSelectedRow(row);
    switch (actionType) {
      case actionTypes.voir:
        setIsVisibleViewModule(true);
        break;
      case actionTypes.modifier:
        setIsModifiDialogOpen(true);
        break;
      case actionTypes.delete:
        setIsDeleteDialogOpen(true);
        break;
      default:
        break;
    }
  }, []);

  const handleDeleteConfirm = useCallback(async () => {
    if (!selectedRow) return;
    try {
      const res = await API.delete(`/modules/${selectedRow.id}`);
      if (res.status === 200 || res.status === 204) {
        handleRefresh();
        setIsDeleteDialogOpen(false);
      }
    } catch (error) {
      console.error("Erreur lors de la suppression :", error.message);
      setIsDeleteDialogOpen(false);
    }
  }, [selectedRow]);

  const getModule = useCallback(async () => {
    try {
      const response = await API.get(`/modules`);
      const data = response.data.data.map((row, index) => ({
        ...row,
        order: index + 1,
      }));
      setRows(data);
    } catch (error) {
      console.error("Erreur lors du chargement des modules :", error.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleRefresh = useCallback(() => {
    setIsLoading(true);
    getModule();
  }, [getModule]);

  useEffect(() => {
    getModule();
  }, [getModule]);

  const columns = useMemo(
    () => [
      {
        field: "order",
        headerName: "#",
        width: 80,
      },
      {
        field: "label",
        headerName: "Label",
        width: 160,
      },
      {
        field: "description",
        headerName: "Description",
        width: 260,
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 80,
        disableExport: true,
        getActions: (params) =>
          Object.entries(actionTypes).map((i, index) => {
            return (
              <GridActionsCellItem
                icon={iconList[index]}
                label={`${i[1]}`}
                key={i[0]}
                onClick={() => handleAction(params.row, i[1])}
                showInMenu
              />
            );
          }),
      },
    ],
    [handleAction]
  );

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbar
        sx={{
          "& .MuiButton-root": {
            color: "#37B049",
          },
          "& .MuiSvgIcon-root": {
            color: "#37B049",
          },
        }}
      />
      <RegisterModuleV2 onRefresh={handleRefresh} />
    </GridToolbarContainer>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        slots={{
          toolbar: () => <CustomToolbar />,
        }}
        columns={columns}
        rows={rows}
        checkboxSelection
        disableRowSelectionOnClick
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pagination.limit,
            },
          },
        }}
        pageSizeOptions={[pagination.limit]}
        loading={isLoading}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "linear-progress",
          },
        }}
      />

      {selectedRow && isVisibleViewModule && (
        <ViewModuleModal
          isVisible={isVisibleViewModule}
          onClose={() => setIsVisibleViewModule(false)}
          module={selectedRow}
        />
      )}
      {isDeleteDialogOpen && selectedRow && (
        <DeleteDialog
          isDeleteDialogOpen={isDeleteDialogOpen}
          setIsDeleteDialogOpen={setIsDeleteDialogOpen}
          handleDeleteConfirm={handleDeleteConfirm}
          name="le module"
        />
      )}
      {selectedRow && isModifiDialogOpen && (
        <ModifiModule
          show={isModifiDialogOpen}
          handleClose={() => setIsModifiDialogOpen(false)}
          moduleId={selectedRow.id}
          initialData={selectedRow}
          onRefresh={handleRefresh}
        />
      )}
    </Box>
  );
};

export default DataGridModule;
